import { render } from "./StartScreenToolTemplate.vue?vue&type=template&id=7028728e&scoped=true"
import script from "./StartScreenToolTemplate.vue?vue&type=script&lang=js"
export * from "./StartScreenToolTemplate.vue?vue&type=script&lang=js"

import "./StartScreenToolTemplate.vue?vue&type=style&index=0&id=7028728e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7028728e"]])

export default __exports__